import React from "react"
import FeaturesListItem from "./featuresListItem"
import useTranslations from "../utils/useTranslations"
import downloadImg from "../images/components/featuresList/system-update-alt-24-px.svg"
import speedUpImg from "../images/components/featuresList/sort-24-px.svg"
import networkImg from "../images/components/featuresList/network-check-24-px.svg"
import watchImg from "../images/components/featuresList/watch-24-px.svg"
import remoteImg from "../images/components/featuresList/speaker-phone-24-px.svg"
import scheduleImg from "../images/components/featuresList/shape.svg"
import playImg from "../images/components/featuresList/play.svg"
import checkImg from "../images/components/featuresList/check.svg"
import smileyImg from "../images/components/featuresList/smiley.svg"
import searchImg from "../images/components/featuresList/search.svg"
import boltImg from "../images/components/featuresList/bolt.svg"
import globeImg from "../images/components/featuresList/globe.svg"
import flashImg from "../images/components/featuresList/flash.svg"
import warningImg from "../images/components/featuresList/warning.svg"
import nopeImg from "../images/components/featuresList/nope.svg"
import batteryImg from "../images/components/featuresList/battery.svg"
import powerImg from "../images/components/featuresList/power.svg"
import wifiImg from "../images/components/featuresList/wifi.svg"

import speed1 from "../images/products/speed-1.png"
import speed12x from "../images/products/speed-1@2x.png"
import speed1Webp from "../images/products/speed-1.webp"
import speed1Webp2x from "../images/products/speed-1@2x.webp"
import speed2 from "../images/products/speed-2.png"
import speed22x from "../images/products/speed-2@2x.png"
import speed2Webp from "../images/products/speed-2.webp"
import speed2Webp2x from "../images/products/speed-2@2x.webp"

const FeaturesList = (props) => {

	const text = props.text
	const t = useTranslations(text)
	const pageName = props.pageName

	const productsWinBittorrentClassicFree = <div className="row m-auto">
		  	<FeaturesListItem img={downloadImg} colSizing="col-md-6 col-lg-4 offset-lg-1">
		  		<span className="feature-list-header" >{t("Download torrents in bulk")}</span>
		  		<p className="feature-list-description mt-3" >{t("BitTorrent Classic is a bulk torrent downloader that helps you to download dozens of files simultaneously.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={speedUpImg} colSizing="col-md-6 col-lg-4 offset-lg-2">
		  		<span className="feature-list-header" >{t("Prioritize for faster downloads")}</span>
		  		<p className="feature-list-description mt-3" >{t("Downloading more than one torrent? Allocate more bandwidth to a specific torrent to download it faster.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={networkImg} colSizing="col-md-6 col-lg-4 offset-lg-1">
		  		<span className="feature-list-header" >{t("Save network resources")}</span>
		  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for your other internet tasks.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={remoteImg} colSizing="col-md-6 col-lg-4 offset-lg-2" id="classic-free-features-btremote-learn-more" learnMore={t('learnMore')} to="https://remote.bittorrent.com">
		  		<span className="feature-list-header" >{t("Manage torrents remotely")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use the remote feature to add torrents from BitTorrent Android or through a browser on any device.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={networkImg} colSizing="col-md-6 col-lg-4 offset-lg-1">
		  		<span className="feature-list-header" >{t("Avoid slow downloads")}</span>
		  		<p className="feature-list-description mt-3" >{t("Quickly check the health of a torrent's swarm before starting and during a download.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={scheduleImg} colSizing="col-md-6 col-lg-4 offset-lg-2">
		  		<span className="feature-list-header" >{t("Schedule for when it’s convenient")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use a scheduler to specify the times of day when to download or seed torrents.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={warningImg} colSizing="col-md-6 col-lg-4 offset-lg-1">
		  		<span className="feature-list-header" >{t("Automate downloads with RSS")}</span>
		  		<p className="feature-list-description mt-3" >{t("Setup RSS feeds to automatically download torrents from your favorite sites.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={boltImg} colSizing="col-md-6 col-lg-4 offset-lg-2">
		  		<span className="feature-list-header" >{t("Supports Windows XP and up")}</span>
		  		<p className="feature-list-description mt-3" >{t("BitTorrent Classic is the best Windows 10 torrent client but also supports XP, Vista, and Windows 7 and 8.")}</p>
		  	</FeaturesListItem>
		  	</div>


	const productsWinBittorrentWebFree = <div className="row m-auto">
			<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" learnMore={t('learnMore')} to="/token/bittorrent-speed/">
		  		<span className="feature-list-header" >{t("Use BTT token to increase download speed")}</span>
		  		<div>
		  			<picture>
	                  <source class="feature-list-speed-img" srcSet={`${speed1Webp} 1x, ${speed1Webp2x} 2x`} type="image/webp"></source>
	                  <img class="feature-list-speed-img" srcSet={`${speed1} 1x, ${speed12x} 2x`} src={speed1} ></img>
	                </picture>
			  		<p className="feature-list-description mt-3" >{t("BitTorrent Speed automatically bids BitTorrent (BTT) to other users for faster speeds.")}</p>
			  	</div>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5">
		  		<span className="feature-list-header" >{t("Earn BTT token rewards for seeding")}</span>
		  		<div>
		  			<picture>
	                  <source class="feature-list-speed-img" srcSet={`${speed2Webp} 1x, ${speed2Webp2x} 2x`} type="image/webp"></source>
	                  <img class="feature-list-speed-img" srcSet={`${speed2} 1x, ${speed22x} 2x`} src={speed2} ></img>
	                </picture>
			  		<p className="feature-list-description mt-3" >{t("When a file finishes downloading, let it seed to earn BitTorrent (BTT).")}</p>
			  	</div>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" img={searchImg} >
		  		<span className="feature-list-header" >{t("Easily find torrents")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use the safe torrent scanner utility to quickly find, download, and play torrents in a few easy steps.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5" img={playImg} >
		  		<span className="feature-list-header" >{t("Play torrent files right away")}</span>
		  		<p className="feature-list-description mt-3" >{t("Play both torrent files and magnet links while they download, all within your browser window.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" img={boltImg} >
		  		<span className="feature-list-header" >{t("Easy, intuitive interface")}</span>
		  		<p className="feature-list-description mt-3" >{t("The web torrent client installs in your favorite web browser and makes torrent downloads simple.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5" img={checkImg} >
		  		<span className="feature-list-header" >{t("Download any file type")}</span>
		  		<p className="feature-list-description mt-3" >{t("BitTorrent Web is not just for video. Download any file to store locally in the folder of your choice.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" img={networkImg} >
		  		<span className="feature-list-header" >{t("Save network resources")}</span>
		  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for your other internet tasks.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5" img={globeImg} >
		  		<span className="feature-list-header" >{t("Available in 15 languages")}</span>
		  		<p className="feature-list-description mt-3" >{t("Localized in over a dozen languages including Russian, Portuguese, Spanish, French, Korean, Italian, and more!")}</p>
		  	</FeaturesListItem>
		  	</div>


	const productsWinBittorrentWebMac = <div className="row m-auto">
			<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" learnMore={t('learnMore')} to="/token/bittorrent-speed/">
		  		<span className="feature-list-header" >{t("Use BTT token to increase download speed")}</span>
		  		<div>
		  			<picture>
	                  <source class="feature-list-speed-img" srcSet={`${speed1Webp} 1x, ${speed1Webp2x} 2x`} type="image/webp"></source>
	                  <img class="feature-list-speed-img" srcSet={`${speed1} 1x, ${speed12x} 2x`} src={speed1} ></img>
	                </picture>
			  		<p className="feature-list-description mt-3" >{t("BitTorrent Speed automatically bids BitTorrent (BTT) to other users for faster speeds.")}</p>
			  	</div>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5">
		  		<span className="feature-list-header" >{t("Earn BTT token rewards for seeding")}</span>
		  		<div>
		  			<picture>
	                  <source class="feature-list-speed-img" srcSet={`${speed2Webp} 1x, ${speed2Webp2x} 2x`} type="image/webp"></source>
	                  <img class="feature-list-speed-img" srcSet={`${speed2} 1x, ${speed22x} 2x`} src={speed2} ></img>
	                </picture>
			  		<p className="feature-list-description mt-3" >{t("When a file finishes downloading, let it seed to earn BitTorrent (BTT).")}</p>
			  	</div>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" img={playImg}>
		  		<span className="feature-list-header" >{t("Play torrent files immediately")}</span>
		  		<p className="feature-list-description mt-3" >{t("Acting as a BitTorrent streaming client, you can play both torrent files and magnet links while they download, all within your browser window.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5" img={checkImg}>
		  		<span className="feature-list-header" >{t("Download any file type")}</span>
		  		<p className="feature-list-description mt-3" >{t("BitTorrent Web for Mac is not just for video. Download any file to store locally in the folder of your choice.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5 offset-lg-1" img={smileyImg}>
		  		<span className="feature-list-header" >{t("Easy and safe")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use the safe torrent scanner utility to quickly find, download, and play torrents in a few easy steps.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem colSizing="col-md-6 col-lg-5" img={networkImg}>
		  		<span className="feature-list-header" >{t("Save network resources")}</span>
		  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for your other internet tasks.")}</p>
		  	</FeaturesListItem>
		  	</div>
		  	


	const productsAndroidBittorrentFree = <div className="row m-auto">
			<FeaturesListItem img={flashImg}>
		  		<span className="feature-list-header" >{t("Lightning fast mobile torrenting")}</span>
		  		<p className="feature-list-description mt-3" >{t("Download torrent files on your mobile device at high speeds using the BitTorrent P2P protocol.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={wifiImg}>
		  		<span className="feature-list-header" >{t("Save data in wifi-only mode")}</span>
		  		<p className="feature-list-description mt-3" >{t("Setup your Android torrent client to download torrents over wifi to save your mobile data plan.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={downloadImg}>
		  		<span className="feature-list-header" >{t("Download torrents in bulk")}</span>
		  		<p className="feature-list-description mt-3" >{t("On a strong network connection? Download torrent files simultaneously without problems.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={playImg} id="android-free-features-btremote-learn-more" learnMore={t('learnMore')} to="https://remote.bittorrent.com">
		  		<span className="feature-list-header" >{t("Remotely add torrents to <span class='d-block'>BitTorrent Classic</span>")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use the remote feature to add torrents to BitTorrent Classic on Windows from your Android torrent client.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={remoteImg}>
		  		<span className="feature-list-header" >{t("Playback files")}</span>
		  		<p className="feature-list-description mt-3" >{t("A built-in media player helps playback the audio and video files downloaded to your phone.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={networkImg}>
		  		<span className="feature-list-header" >{t("Save network resources")}</span>
		  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for your other non-torrent mobile tasks.")}</p>
		  	</FeaturesListItem>

		  	</div>


	const productsAndroidBittorrentPro = <div className="row m-auto">
		  	<FeaturesListItem img={nopeImg}>
		  		<span className="feature-list-header" >{t("No ads, no distractions")}</span>
		  		<p className="feature-list-description mt-3" >{t("The most trusted torrent downloader for Android is ad-free.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={batteryImg}>
		  		<span className="feature-list-header" >{t("Preserve your battery")}</span>
		  		<p className="feature-list-description mt-3" >{t("Automatically suspend torrent mobile activity when your battery drops below a predefined level.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={powerImg}>
		  		<span className="feature-list-header" >{t("Save data with auto-shutdown")}</span>
		  		<p className="feature-list-description mt-3" >{t("Even if BitTorrent Android is in the background, you can automatically stop torrents when your mobile torrent downloads are finished.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={wifiImg}>
		  		<span className="feature-list-header" >{t("Save data in wifi-only mode")}</span>
		  		<p className="feature-list-description mt-3" >{t("Setup your Android torrent client to download over wifi-only to save your mobile data plan.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={boltImg}>
		  		<span className="feature-list-header" >{t("Lightning fast mobile torrenting")}</span>
		  		<p className="feature-list-description mt-3" >{t("Download torrent files on your mobile device at high speeds using the BitTorrent P2P protocol.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={downloadImg}>
		  		<span className="feature-list-header" >{t("Download torrents in bulk")}</span>
		  		<p className="feature-list-description mt-3" >{t("On a strong connection? Download multiple torrent files from your mobile device simultaneously.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={playImg}>
		  		<span className="feature-list-header" >{t("Playback files")}</span>
		  		<p className="feature-list-description mt-3" >{t("The built-in torrent player for Android helps playback audio and video files downloaded to your phone.")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={remoteImg} id="android-pro-features-btremote-learn-more" learnMore={t('Learn more')} to="https://remote.bittorrent.com">
		  		<span className="feature-list-header" >{t("Remotely add torrents to <span class='d-block'>BitTorrent Classic</span>")}</span>
		  		<p className="feature-list-description mt-3" >{t("Use the remote feature to add torrents to BitTorrent Classic on Windows from your Android torrent client. ")}</p>
		  	</FeaturesListItem>
		  	<FeaturesListItem img={networkImg}>
		  		<span className="feature-list-header" >{t("Save network resources")}</span>
		  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for other non-BitTorrent mobile tasks.")}</p>
		  	</FeaturesListItem>
		  	{/* <FeaturesListItem img={nopeImg}> */}
		  	{/* 	<span className="feature-list-header" >{t("Light and limitless")}</span> */}
		  	{/* 	<p className="feature-list-description mt-3" >{t("Download torrents on Android in a beautifully clean design without speed or size limits.")}</p> */}
		  	{/* </FeaturesListItem> */}
		  	</div>

	if(pageName === 'products_win_bittorrent-classic-free'){
		return productsWinBittorrentClassicFree
	} 

	if (pageName === 'products_win_bittorrent-web-free'){
		return productsWinBittorrentWebFree
	}

	if (pageName === 'products_mac_bittorrent-web-free'){
		return productsWinBittorrentWebMac
	}

	if (pageName === 'products_android_bittorrent-android-free'){
		return productsAndroidBittorrentFree
	}

	if (pageName === 'products_android_bittorrent-android-pro'){
		return productsAndroidBittorrentPro
	}


	return(
		<div className="row m-auto">
			{/* { */}
			{/* 	!props.isMac && */}
			{/* 	<> */}
			{/* 	  	<FeaturesListItem learnMore={t('Learn more')} to="/token/bittorrent-speed"> */}
			{/* 	  		<span className="feature-list-header" >{t("Get faster downloads")}</span> */}
			{/* 	  		<p className="feature-list-description mt-3" >{t("BitTorrent Speed automatically bids BitTorrent (BTT) to other users for faster speeds.")}</p> */}
			{/* 	  	</FeaturesListItem> */}
			{/* 	  	<FeaturesListItem learnMore={t('Learn more')} to="/token/bittorrent-speed"> */}
			{/* 	  		<span className="feature-list-header" >{t("Earn token rewards for seeding")}</span> */}
			{/* 	  		<p className="feature-list-description mt-3" >{t("When a file finishes downloading, let it seed to earn BitTorrent (BTT). The longer you seed, the more you can earn.")}</p> */}
			{/* 	  	</FeaturesListItem> */}
			{/*   	</> */}
			{/* } */}
	  	<FeaturesListItem img={downloadImg}>
	  		<span className="feature-list-header" >{t("Download torrents in bulk")}</span>
	  		<p className="feature-list-description mt-3" >{t("The lightweight BitTorrent client serves as a bulk torrent downloader to help you to download dozens of files simultaneously.")}</p>
	  	</FeaturesListItem>
	  	<FeaturesListItem img={speedUpImg}>
	  		<span className="feature-list-header" >{t("Assign priority to speed up downloads")}</span>
	  		<p className="feature-list-description mt-3" >{t("Downloading more than one torrent? Allocate more bandwidth to a specific torrent to download it faster.")}</p>
	  	</FeaturesListItem>
	  	<FeaturesListItem img={networkImg}>
	  		<span className="feature-list-header" >{t("Save network resources")}</span>
	  		<p className="feature-list-description mt-3" >{t("Set download/upload speed limits to free up network resources for other tasks.")}</p>
	  	</FeaturesListItem>
	  	<FeaturesListItem img={remoteImg}>
	  		<span className="feature-list-header" >{t("Avoid slow downloads")}</span>
	  		<p className="feature-list-description mt-3" >{t("Quickly check the health of a torrent's swarm before starting and during a download.")}</p>
	  	</FeaturesListItem>
	  	<FeaturesListItem img={watchImg} id="homepage-features-btremote-learn-more" learnMore={t('Learn more')} to="https://remote.bittorrent.com">
	  		<span className="feature-list-header" >{t("Manage torrents remotely")}</span>
	  		<p className="feature-list-description mt-3" >{t("Use the remote feature to add torrents from BitTorrent Android or through a browser on any device.")}</p>
	  	</FeaturesListItem>
	  	<FeaturesListItem img={scheduleImg}>
	  		<span className="feature-list-header" >{t("Schedule for when it’s convenient")}</span>
	  		<p className="feature-list-description mt-3" >{t("Use a scheduler to specify the times of day when to download or seed using your torrent program.")}</p>
	  	</FeaturesListItem>
	</div>
	)
}

export default FeaturesList
